module.exports = __webpack_public_path__ + "img/facts.5e4cfc67.gif";